import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import InitialsCircle from './InitialsCircle';

const TopBannerContainer = styled.div`
  display: flex;
  font-weight: 900;
  background-color: #66AFE9;
  color: #FFF;
  height: 80px;
`;

const ProfileName = styled.div`
  font-size: 2em;
  margin-bottom: 10px;
  align-self: flex-end;
  flex-wrap: wrap;

  @media(max-width: 720px) {
    font-size: 1.5em;
    line-height: 1;
    max-width: 225px;
  }
`;

const TopBanner = ({ initials, initialsColor, label }) => (
  <TopBannerContainer>
    <InitialsCircle initials={initials} initialsColor={initialsColor} />
    <ProfileName>
      {label}
    </ProfileName>
  </TopBannerContainer>
);

export default TopBanner;

const { string } = PropTypes;

TopBanner.propTypes = {
  initials: string,
  initialsColor: string,
  label: string
};
